var swatchesSlider = document.querySelector('.swatches_slider');

if (swatchesSlider) {
  const swiper = new Swiper('.swatches_slider', {
    slidesPerView: 8,
    spaceBetween: 0,
    breakpoints: {
      480: {
        slidesPerView: 11,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 15,
        spaceBetween: 0,
      },
      990: {
        slidesPerView: 14,
        spaceBetween: 0,
      },
      1280: {
        slidesPerView: 18,
        spaceBetween: 0,
      },
    },
  });
}
